(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-store-redirect"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var redirectBlocks = document.querySelectorAll('[data-app-store-redirect]');

    redirectBlocks.forEach(function (block) {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera || '';
      var platform = navigator.platform || '';
      var maxTouchPoints = navigator.maxTouchPoints || 0;
      var iosUrl = block.getAttribute('data-ios-url');
      var androidUrl = block.getAttribute('data-android-url');
      var fallbackUrl = block.getAttribute('data-fallback-url');
      var fallbackLink = block.querySelector('[data-app-store-redirect-fallback]');
      var targetUrl = fallbackUrl;
      var isIPadOS = platform === 'MacIntel' && maxTouchPoints > 1;
      var isIOS = /iPad|iPhone|iPod/.test(userAgent) || isIPadOS;
      var isAndroid = /Android/i.test(userAgent);

      if (isIOS) {
        targetUrl = iosUrl;
      } else if (isAndroid) {
        targetUrl = androidUrl;
      }

      if (fallbackLink) {
        fallbackLink.setAttribute('href', targetUrl);
      }

      if (targetUrl) {
        window.location.replace(targetUrl);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-top-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('main-top-banner')) {
    customElements.define(
      'main-top-banner',
      class MainTopBanner extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.viewport = this.querySelector('.main-top-banner__viewport');
          this.track = this.querySelector('.main-top-banner__track');
          this.realSlides = [...this.querySelectorAll('[data-slide]:not(.is-clone)')];
          this.count = this.realSlides.length;
          this.current = this.count > 1 ? 1 : 0;
          this.autoplay = this.dataset.autoplay === 'true';
          this.autoplayDelay = parseInt(this.dataset.autoplayDelay, 10) || 6000;
          this.autoplayTimer = null;
          this.userPaused = !this.autoplay;
          this.dragging = false;
          this.dragDelta = 0;
          this.suppressClick = false;
          this.loopResetting = false;
          this.hasLoop = this.count > 1;
          this.slides = [...this.querySelectorAll('[data-slide]')];
          this.dialog = document.getElementById(this.dataset.dialogId);
          this.viewAllButton = this.querySelector('[data-action="view-all"]');
          this.pauseButton = this.querySelector('[data-action="toggle-autoplay"]');

          if (!this.track || this.count === 0) return;

          this.bindEvents();
          this.setPosition(false);
          this.updateActiveState();

          if (!this.userPaused && !this.reducedMotion()) this.startAutoplay();
          this.updateAutoplayButton();
        }

        disconnectedCallback() {
          this.stopAutoplay();
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.visibilityHandler) document.removeEventListener('visibilitychange', this.visibilityHandler);
        }

        bindEvents() {
          this.querySelector('[data-action="previous"]')?.addEventListener('click', () => this.manualNavigate(this.current - 1));
          this.querySelector('[data-action="next"]')?.addEventListener('click', () => this.manualNavigate(this.current + 1));
          this.querySelectorAll('[data-preview-action]').forEach((button) => {
            const direction = button.dataset.previewAction === 'previous' ? -1 : 1;
            button.addEventListener('click', () => this.manualNavigate(this.current + direction));
          });
          this.pauseButton?.addEventListener('click', () => this.toggleAutoplay());
          this.viewAllButton?.addEventListener('click', (event) => this.openDialog(event));
          this.querySelector('[data-action="close-dialog"]')?.addEventListener('click', (event) => this.closeDialog(event));
          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.closeDialog(event);
          });
          this.dialog?.addEventListener('close', () => this.handleDialogClosed());

          this.viewport.addEventListener('pointerdown', (event) => this.startDrag(event));
          this.viewport.addEventListener('pointermove', (event) => this.moveDrag(event));
          this.viewport.addEventListener('pointerup', (event) => this.endDrag(event));
          this.viewport.addEventListener('pointercancel', (event) => this.cancelDrag(event));
          this.addEventListener('click', (event) => {
            if (!this.suppressClick) return;

            this.suppressClick = false;
            if (event.target.closest('[data-slide]')) {
              event.preventDefault();
              event.stopPropagation();
            }
          }, true);
          this.addEventListener('keydown', (event) => this.handleKeydown(event));
          this.addEventListener('shopify:block:select', (event) => this.handleBlockSelect(event));
          this.addEventListener('shopify:block:deselect', () => this.handleBlockDeselect());

          this.resizeObserver = new ResizeObserver(() => this.setPosition(false));
          this.resizeObserver.observe(this.viewport);
          this.visibilityHandler = () => {
            if (document.hidden) {
              this.stopAutoplay();
            } else if (!this.userPaused && !this.reducedMotion()) {
              this.startAutoplay();
            }
          };
          document.addEventListener('visibilitychange', this.visibilityHandler);
        }

        getTranslate(position) {
          const slide = this.slides[position] || this.realSlides[0];
          const slideWidth = slide.getBoundingClientRect().width;
          const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
          const centeredOffset = (this.viewport.clientWidth - slideWidth) / 2;
          return centeredOffset - position * (slideWidth + gap);
        }

        setPosition(animate = true, offset = 0) {
          if (!this.track || !this.slides) return;
          this.track.style.transition = animate ? '' : 'none';
          this.track.style.transform = `translate3d(${this.getTranslate(this.current) + offset}px, 0, 0)`;
          if (!animate && !this.dragging && !this.loopResetting) {
            this.track.offsetHeight;
            this.track.style.transition = '';
          }
        }

        rebaseLoopPosition(position, offset = 0) {
          this.loopResetting = true;
          this.classList.add('is-loop-resetting');
          this.current = position;
          this.updateActiveState();
          this.setPosition(false, offset);
          this.track.offsetHeight;
          this.track.style.transition = '';
          this.loopResetting = false;
          this.classList.remove('is-loop-resetting');
        }

        updateActiveState() {
          const activeRealIndex = this.hasLoop ? (this.current - 1 + this.count) % this.count : this.current;
          this.slides.forEach((slide, index) => {
            const active = index === this.current;
            const clone = slide.classList.contains('is-clone');
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', active && !clone ? 'false' : 'true');
            if (!clone) slide.toggleAttribute('inert', !active);
          });
          const currentLabel = this.querySelector('[data-current]');
          if (currentLabel) currentLabel.textContent = String(Math.max(0, activeRealIndex + 1));
        }

        goTo(position, offset = 0) {
          if (this.count < 2 || this.dragging) return;
          if (this.hasLoop && position === 0) {
            this.rebaseLoopPosition(this.count + 1, offset);
            position = this.count;
          } else if (this.hasLoop && position === this.count + 1) {
            this.rebaseLoopPosition(0, offset);
            position = 1;
          }
          this.current = this.hasLoop ? position : Math.max(0, Math.min(position, this.count - 1));
          this.updateActiveState();
          this.setPosition(true);
        }

        manualNavigate(position) {
          this.goTo(position);
          this.restartAutoplay();
        }

        startAutoplay() {
          if (this.userPaused || this.count < 2 || this.autoplayTimer) return;
          this.autoplayTimer = window.setInterval(() => this.goTo(this.current + 1), this.autoplayDelay);
        }

        stopAutoplay() {
          if (!this.autoplayTimer) return;
          window.clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }

        restartAutoplay() {
          this.stopAutoplay();
          if (!this.userPaused && !this.reducedMotion()) this.startAutoplay();
        }

        toggleAutoplay() {
          this.userPaused = !this.userPaused;
          if (this.userPaused) {
            this.stopAutoplay();
          } else if (!this.reducedMotion()) {
            this.startAutoplay();
          }
          this.updateAutoplayButton();
        }

        updateAutoplayButton() {
          if (!this.pauseButton) return;
          const paused = this.userPaused;
          this.pauseButton.classList.toggle('is-paused', paused);
          this.pauseButton.setAttribute('aria-pressed', String(paused));
          this.pauseButton.setAttribute('aria-label', paused ? this.pauseButton.dataset.labelPlay : this.pauseButton.dataset.labelPause);
        }

        reducedMotion() {
          return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }

        dragThreshold() {
          return Math.max(10, this.viewport.clientWidth * 0.08);
        }

        startDrag(event) {
          if (this.count < 2 || event.button > 0 || event.target.closest('[data-preview-action]')) return;
          this.suppressClick = false;
          this.dragging = true;
          this.dragStartX = event.clientX;
          this.dragDelta = 0;
          this.stopAutoplay();
          this.track.style.transition = 'none';
        }

        moveDrag(event) {
          if (!this.dragging) return;
          this.dragDelta = event.clientX - this.dragStartX;
          if (Math.abs(this.dragDelta) >= this.dragThreshold()) {
            event.preventDefault();
            if (!this.viewport.hasPointerCapture?.(event.pointerId)) {
              this.viewport.setPointerCapture?.(event.pointerId);
            }
          }
          this.setPosition(false, this.dragDelta);
        }

        endDrag(event) {
          if (!this.dragging) return;
          this.dragging = false;
          if (this.viewport.hasPointerCapture?.(event.pointerId)) {
            this.viewport.releasePointerCapture(event.pointerId);
          }
          const threshold = this.dragThreshold();
          if (Math.abs(this.dragDelta) >= threshold) {
            this.suppressClick = true;
            this.goTo(this.current + (this.dragDelta < 0 ? 1 : -1), this.dragDelta);
          } else {
            this.suppressClick = false;
            this.setPosition(true);
          }
          this.restartAutoplay();
        }

        cancelDrag(event) {
          if (!this.dragging) return;
          this.dragging = false;
          if (this.viewport.hasPointerCapture?.(event.pointerId)) {
            this.viewport.releasePointerCapture(event.pointerId);
          }
          this.suppressClick = false;
          this.setPosition(true);
          this.restartAutoplay();
        }

        handleKeydown(event) {
          if (event.target.closest('dialog')) return;
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.manualNavigate(this.current - 1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.manualNavigate(this.current + 1);
          }
        }

        handleBlockSelect(event) {
          const selectedSlide = event.target.closest('[data-slide-index]');
          if (!selectedSlide || !this.contains(selectedSlide)) return;

          const blockIndex = Number(selectedSlide.dataset.slideIndex);
          if (!Number.isInteger(blockIndex)) return;

          this.stopAutoplay();
          this.goTo(blockIndex + (this.hasLoop ? 1 : 0));
        }

        handleBlockDeselect() {
          if (!this.userPaused && !this.reducedMotion()) this.startAutoplay();
        }

        openDialog(event) {
          if (!this.dialog) return;
          this.restoreDialogFocus = !event || event.detail === 0;
          this.stopAutoplay();
          if (typeof this.dialog.showModal === 'function') {
            this.dialog.showModal();
          } else {
            this.dialog.setAttribute('open', '');
          }
          this.viewAllButton?.setAttribute('aria-expanded', 'true');
        }

        closeDialog(event) {
          if (!this.dialog) return;
          if (event?.detail > 0) this.restoreDialogFocus = false;
          if (typeof this.dialog.close === 'function' && this.dialog.open) {
            this.dialog.close();
            return;
          } else {
            this.dialog.removeAttribute('open');
          }
          this.handleDialogClosed();
        }

        handleDialogClosed() {
          if (this.restoreDialogFocus) {
            this.viewAllButton?.focus();
          } else {
            this.viewAllButton?.blur();
          }
          this.viewAllButton?.setAttribute('aria-expanded', 'false');
          if (!this.userPaused && !this.reducedMotion()) this.startAutoplay();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
